import React, {useState} from "react";
import {Table, Space, Pagination, DatePicker, Badge, Modal, notification, Input, Button, Tooltip} from 'antd';
import dayjs from "dayjs";
import RequestApi from "../api/RequestApi";
import EntityApi from "../api/EntityApi";
import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRemove} from "@fortawesome/free-solid-svg-icons";
import {SearchOutlined, CopyOutlined} from '@ant-design/icons';
import {useDispatch} from "react-redux";
import {resetMenu} from "../redux/slices/menuSlice";

const LinkOrder = () => {

    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(resetMenu());
    }, [])

    const [apiNotification, contextHolder] = notification.useNotification();
    const [isReload, setIsReload] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [items, setItems] = React.useState([]);
    const [total, setTotal] = React.useState(0);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const [sortField, setSortField] = useState('id');
    const [sortOrder, setSortOrder] = useState('desc');

    // form
    const [isAddOpen, setAddOpen] = React.useState(false);
    const [formName, setFormName] = React.useState('');
    const [isErrorName, setErrorName] = React.useState(false);
    const [formPrice, setFormPrice] = React.useState('');
    const [isErrorPrice, setErrorPrice] = React.useState(false);
    const [inputDatePayment, setInputDatePayment ] = React.useState('');

    // filter
    const [filter, setFilter] = useState({});
    const [filterId, setFilterId] = useState('');
    const [filterClient, setFilterClient] = useState('');
    const [filterName, setFilterName] = useState('');
    const [filterPriceFrom, setFilterPriceFrom] = React.useState('');
    const [filterPriceTo, setFilterPriceTo] = React.useState('');
    const [filterDateFrom, setFilterDateFrom] = useState('');
    const [filterDateTo, setFilterDateTo] = useState('');
    const [filterDateExpireFrom, setFilterDateExpireFrom] = useState('');
    const [filterDateExpireTo, setFilterDateExpireTo] = useState('');
    const [filterStatus, setFilterStatus] = useState('');


    const handleReset = (confirm) => {
        setFilterId('');
        setFilterClient('');
        setFilterName('');
        setFilterPriceFrom('');
        setFilterPriceTo('');
        setFilterDateFrom('');
        setFilterDateTo('');
        setFilterDateExpireFrom('');
        setFilterDateExpireTo('');
        setFilterStatus('');
        setFilter({});
        setIsReload(!isReload);
        confirm();
    }

    const handleSearch = (field, confirm) => {
        confirm();
        applyFilter();
        setIsReload(!isReload);
    }

    const applyFilter = () => {
        let newFilter = filter;
        newFilter.id = filterId;
        newFilter.client = filterClient;
        newFilter.name = filterName;
        newFilter.price = [filterPriceFrom, filterPriceTo];
        newFilter.dt = [filterDateFrom, filterDateTo];
        newFilter.expire = [filterDateExpireFrom, filterDateExpireTo];
        newFilter.status = filterStatus;
        setFilter(newFilter);
    }

    const RenderSearchFooter = ({field, confirm}) => {
        return <Space className={'p-2'}>
            <Button type={'primary'} onClick={() => confirm && handleSearch(field, confirm)}>Найти</Button>
            <Button type={'default'} onClick={() => confirm && handleReset(confirm)}>Сбросить</Button>
        </Space>
    }

    const getColumnSearch = (field) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => {
            if (field === 'id') {
                return <>
                    <div className={'flex p-2'}>
                        <Input isFullWidth={true} type={'text'} value={filterId} placeholder={'Номер заказа'} onChange={(evt)=> setFilterId(evt.target.value)}/>
                    </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
            if (field === 'client') {
                return <>
                    <div className={'flex p-2'} style={{width: '300px'}}>
                        <Input isFullWidth={true} type={'text'} value={filterClient} placeholder={'Имя пользователя'} onChange={(evt)=> setFilterClient(evt.target.value)}/>
                    </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
            if (field === 'name') {
                return <>
                    <div className={'flex p-2'} style={{width: '300px'}}>
                        <Input isFullWidth={true} type={'text'} value={filterName} placeholder={'Введите название'} onChange={(evt)=> setFilterName(evt.target.value)}/>
                    </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
            if (field === 'price') {
                return <><div className={'flex p-2'}>
                    <Input type={'text'} value={filterPriceFrom} placeholder={'от'} onChange={(evt)=> setFilterPriceFrom(evt.target.value)}/>
                    <Input className={'ml-4'} type={'text'} value={filterPriceTo} placeholder={'до'} onChange={(evt)=> setFilterPriceTo(evt.target.value)}/>
                </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
            if (field === 'dt') {
                return <>
                    <div className={'flex p-2'}>
                        <DatePicker value={filterDateFrom ? dayjs(filterDateFrom, 'DD.MM.YYYY') : ''} onChange={(date, dateString) => setFilterDateFrom(dateString)} placeholder={'от'} format={'DD.MM.YYYY'}/>
                        <div className={'pl-4'}>
                            <DatePicker value={filterDateTo ? dayjs(filterDateTo, 'DD.MM.YYYY') : ''} onChange={(date, dateString) => setFilterDateTo(dateString)} placeholder={'до'} format={'DD.MM.YYYY'}/>
                        </div>
                    </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
            if (field === 'expire') {
                return <>
                    <div className={'flex p-2'}>
                        <DatePicker value={filterDateExpireFrom ? dayjs(filterDateExpireFrom, 'DD.MM.YYYY') : ''} onChange={(date, dateString) => setFilterDateExpireFrom(dateString)} placeholder={'от'} format={'DD.MM.YYYY'}/>
                        <div className={'pl-4'}>
                            <DatePicker value={filterDateExpireTo ? dayjs(filterDateExpireTo, 'DD.MM.YYYY') : ''} onChange={(date, dateString) => setFilterDateExpireTo(dateString)} placeholder={'до'} format={'DD.MM.YYYY'}/>
                        </div>
                    </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
            if (field === 'status') {
                return <>
                    <div className={'p-2'}>
                        <label className={'flex cursor-pointer'}>
                            <input type={'radio'} checked={filterStatus === ''}
                                   onChange={e => {setFilterStatus('')}}/>
                            <div className={'pl-4'}>Все</div>
                        </label>
                        <label className={'flex cursor-pointer'}>
                            <input type={'radio'} checked={filterStatus === 'N'}
                                   onChange={e => {setFilterStatus('N')}}/>
                            <div className={'pl-4'}>Новый</div>
                        </label>
                        <label className={'flex cursor-pointer'}>
                            <input type={'radio'} checked={filterStatus === 'P'}
                                   onChange={e => {setFilterStatus('P')}}/>
                            <div className={'pl-4'}>Оплачен</div>
                        </label>
                    </div>
                    <RenderSearchFooter field={field} confirm={confirm}/>
                </>
            }
        },
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        )
    })

    const columns = [
        {
            title: 'Информация о заказе-ссылке',
            responsive: ['xs'],
            ...getColumnSearch('name'),
            render: (item) => {
                return <>
                    <div><span className={'font-bold'}>ID: </span>{item.id}</div>
                    <div><span className={'font-bold'}>Наименование: </span>{item.name}</div>
                    <div><span className={'font-bold'}>Дата: </span>{item.dt}</div>
                    <div><span className={'font-bold'}>Срок до: </span>{item.expire ? item.expire : 'Без срока'}</div>
                    <div><span className={'font-bold'}>Стоимость: </span>{item.price} руб.</div>
                    <div><span className={'font-bold'}>Создатель: </span><Link
                        to={'/cabinet/users/' + item.creator.id}>{item.creator.name}</Link></div>
                    <div><span className={'font-bold'}>Статус: </span>
                        <>
                            {item.status === 'N' && <Badge status="default" text={'Новый'}/>}
                            {item.status === 'C' && <Badge status="error" text={'Отменен'}/>}
                            {item.status === 'P' && <Badge status="success" text={'Оплачено'}/>}
                            {item.status === 'P' && item.payment_information &&
                                <div className={"text-xs"} style={{color: 'grey'}}>{item.payment_information}</div>}
                        </>
                    </div>
                    <div className="flex justify-center items-center space-x-2 mt-2">
                        {
                            item.status === 'N' &&
                            <Button type={'default'} onClick={() => copyTextToClipboard(item.link)}><CopyOutlined/> Скопировать ссылку</Button>
                        }
                        {
                            item.status === 'N' &&
                            <Button onClick={() => onDelete(item.id)} type={'default'}><FontAwesomeIcon className={'text-error'} icon={faRemove}/> Удалить</Button>
                        }
                    </div>
                </>
            }
        },
        {
            title: 'ID',
            width: 100,
            dataIndex: 'id',
            sorter: true,
            responsive: ['md'],
            ...getColumnSearch('id')
        },
        {
            title: 'Дата',
            dataIndex: 'dt',
            sorter: true,
            width: 160,
            responsive: ['md'],
            ...getColumnSearch('dt'),
        },
        {
            title: 'Срок до',
            dataIndex: 'expire',
            sorter: true,
            width: 160,
            responsive: ['md'],
            ...getColumnSearch('expire'),
        },
        {
            title: 'Создатель',
            dataIndex: 'creator',
            //sorter: true,
            width: 300,
            responsive: ['md'],
            ...getColumnSearch('client'),
            render: (creator, record) => (
                <Link to={'/cabinet/users/' + creator.id}>{creator.name}</Link>
            )
        },
        {
            title: 'Наименование',
            dataIndex: 'name',
            sorter: true,
            responsive: ['md'],
            ...getColumnSearch('name'),
        },
        {
            title: 'Стоимость',
            dataIndex: 'price',
            sorter: true,
            width: 150,
            responsive: ['md'],
            ...getColumnSearch('price')
        },
        {
            title: 'Статус',
            dataIndex: 'status',
            //sorter: true,
            width: 200,
            ...getColumnSearch('status'),
            responsive: ['md'],
            render: (status, record) => {
                return <>
                    { status === 'N' && <Badge status="default" text={'Новый'} /> }
                    { status === 'C' && <Badge status="error" text={'Отменен'} /> }
                    { status === 'P' && <Badge status="success" text={'Оплачено'} /> }
                    { status === 'P' && record.payment_information &&
                        <div className={"text-xs"} style={{color: 'grey'}}>{record.payment_information}</div>}
                </>
            }
        },
        {
            title: '',
            width: 100,
            responsive: ['md'],
            render: (record) => {
                return <div className="flex justify-center items-center space-x-2">
                    {
                        record.status === 'N' && <Tooltip title="Скопировать ссылку">
                            <button onClick={() => copyTextToClipboard(record.link)}>
                                <CopyOutlined />
                            </button>
                        </Tooltip>
                    }
                    {
                        record.status === 'N' && <Tooltip title="Удалить">
                        <button onClick={() => onDelete(record.id)}
                                className="btn h-8 w-8 p-0 text-error hover:bg-error/20 focus:bg-error/20 active:bg-error/25">
                            <FontAwesomeIcon icon={faRemove}/>
                        </button>
                        </Tooltip>
                    }
                </div>
            }
        }
    ]

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter.hasOwnProperty("column")) {
            if (sorter.field !== undefined) {
                setSortField(sorter.field);
            } else {
                setSortField('id');
            }
            if (sorter.order === 'ascend') {
                setSortOrder('asc');
            }
            if (sorter.order === 'descend') {
                setSortOrder('desc');
            }
        } else {
            setSortField('id');
            setSortOrder('desc');
        }
        setIsReload(!isReload);
    }

    React.useEffect(() => {
        setIsLoading(true);
        EntityApi.getBy('private/link-order', {
            filter: filter,
            sort: {
                [sortField]: sortOrder
            },
            page: page,
            size: pageSize
        }).then((data) => {
            if (data.status === EntityApi.STATUS_SUCCESS) {
                setItems(data.content.items);
                setTotal(data.payload.total);
                setPage(data.payload.currentPage);
            }
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        })

    }, [isReload]);

    const onPaginate = (p) => {
        setPage(p);
        setIsReload(!isReload);
    }

    const onFormPrice = (value) => {
        value = value.replace(/\D/g, '');
        setFormPrice(value);
    }

    const onAdd = () => {

        let isError = false;
        if (formName.length <= 5) {
            setErrorName(true);
            isError = true;
        }
        if (parseInt(formPrice) < 1) {
            setErrorPrice(true);
            isError = true;
        }

        if (isError) {
            return false;
        }

        RequestApi.put('private/link-order', {
            name: formName,
            price: formPrice,
            expire: inputDatePayment
        }).then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                setIsReload(!isReload);
                setAddOpen(false);
            } else {
                var mes = '';
                data.error.messages.forEach((message) => {
                    mes +=  '' + message;
                })
                apiNotification['error']({
                    message: 'Ошибка создания заказа-ссылки',
                    description: mes,
                });
            }
        }).catch(err => {
            apiNotification['error']({
                message: 'Ошибка сервера',
                description:
                    'Произошла ошибка сервера, пожалуйста, обратитесь к разработчику',
            });
        })
    }

    const copyTextToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            apiNotification['success']({
                message: 'Копирование ссылки',
                description:
                    'Ссылка успешно скопирована в буфер обмена',
            });
        } catch (err) {
            console.error('Ошибка:', err);
        }
    };

    const onDeleteConfirm = (orderId) => {
        EntityApi.delete('private/link-order', orderId).then((data) => {
            if (data.status === RequestApi.STATUS_SUCCESS) {
                Modal.destroyAll();
                setIsReload(!isReload);
            } else {
                var mes = '';
                data.error.messages.forEach((message) => {
                    mes +=  '' + message;
                })
                apiNotification['error']({
                    message: 'Ошибка удаления заказа-ссылки',
                    description: mes,
                });
            }
        }).catch(err => {
            apiNotification['error']({
                message: 'Ошибка сервера',
                description:
                    'Произошла ошибка сервера, пожалуйста, обратитесь к разработчику',
            });
        });
    }

    const onDelete = (orderId) => {
        Modal.confirm({
            title: 'Подтвердите удаление',
            content: 'Вы действительно хотите удалить заказ-ссылку?',
            footer: (_, { OkBtn, CancelBtn }) => (
                <div className={'flex justify-end'}>
                    <Button onClick={() => {Modal.destroyAll()}}>Отмена</Button>
                    <Button onClick={() => onDeleteConfirm(orderId)} type={'primary'}>Удалить</Button>
                </div>
            ),
        });
    }

    return <>
        {contextHolder}
        <div className="flex items-center justify-between py-5 lg:py-6">
            <div className="flex items-center space-x-1">
                <h2 className="line-clamp-1 text-xl font-medium text-slate-700 dark:text-navy-50 lg:text-2xl">
                    <span>Заказы-ссылки</span>
                </h2>
            </div>
        </div>
        <div className="card px-4 pb-4">
            <div className="my-3 flex h-8 items-center justify-between">
                <h2 className="line-clamp-1 font-medium tracking-wide text-slate-700 dark:text-navy-100 lg:text-base">
                    Список заказов-ссылок
                </h2>
                <Button onClick={() => setAddOpen(true)} type={'default'}>+ Создать</Button>
            </div>
            <Table rowKey={'id'} loading={isLoading} onChange={handleTableChange} columns={columns} dataSource={items} pagination={false}></Table>
            <div className={'pt-3'}>
                <Pagination defaultCurrent={page} pageSize={pageSize} showSizeChanger={true} onShowSizeChange={(current, size) => setPageSize(size)} onChange={onPaginate} total={total}/>
            </div>
        </div>
        <Modal
            title="Создать заказ-ссылку"
            open={isAddOpen}
            onCancel={() => setAddOpen(false)}
            footer={(_, { OkBtn, CancelBtn }) => (
                <div className={'flex justify-end'}>
                    <Button onClick={() => setAddOpen(false)}>Отменить</Button>
                    <Button className={'ml-4'} onClick={onAdd} type={'primary'}>Создать</Button>
                </div>
            )}
        >
            <div className={'pb-3 pt-3 flex'}>
                <div className={'w-6/12'}>Название: *</div>
                <Input value={formName} status={isErrorName ? 'error' : ''}
                       onChange={(evt) => setFormName(evt.target.value)}/>
            </div>
            <div className={'pb-3 flex'}>
                <div className={'w-6/12'}>Стоимость: *</div>
                <Input value={formPrice} status={isErrorPrice ? 'error' : ''}
                       onChange={(evt) => onFormPrice(evt.target.value)}/>
            </div>
            <div className={'pb-3 flex'}>
                <div className={'w-6/12'}>Срок до:</div>
                <DatePicker
                    value={inputDatePayment ? dayjs(inputDatePayment, 'DD.MM.YYYY') : ''}
                    showTime={{format: 'HH:mm'}}
                    format={'DD.MM.YYYY HH:mm'}
                    style={{width: '100%'}}
                    onChange={(date, dateString) => setInputDatePayment(dateString)}/>
            </div>
        </Modal>
    </>

}

export default LinkOrder;
